// Vendor libraries
import { CommonModule } from '@angular/common';
// Modules
import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';
import { FormsModule } from '@angular/forms';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { InviteFriendModalModule } from 'AccountsApp/ts/features/invite-friend-modal/invite-friend-modal.module';
import { RefreshRequiredModalModule } from 'NewAngular/features/components/modals/refresh-required-modal/refresh-required-modal.module';
import { StringPipesModule } from 'NewAngular/features/pipes/string/string-pipes.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { TopBarNavAutocompleteModule } from 'SearchApp/ts/features/top-bar-nav-autocomplete/top-bar-nav-autocomplete.module';
import { NotificationsModalModule } from 'NotificationsApp/ts/features/notifications-modal/notifications-modal.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import * as i0 from "@angular/core";
export class NavigationModule {
}
NavigationModule.ɵfac = function NavigationModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NavigationModule)(); };
NavigationModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: NavigationModule });
NavigationModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseAutocompleteModule,
        CommonModule,
        FormsModule,
        IconModule,
        InviteFriendModalModule,
        NotificationsModalModule,
        RefreshRequiredModalModule,
        StringPipesModule,
        TooltipModule,
        TopBarNavAutocompleteModule,
        LoadingSymbolModule] });
